const ALPHA_PROVIDERS = ['Google', 'SignInWithApple'];

export function readAlphaDomainPool() {
  const raw = localStorage.getItem('alphaDomainPool');
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    localStorage.removeItem('alphaDomainPool');
    return null;
  }
}

export function shouldUseAlphaPool(provider, pool) {
  return Boolean(pool && ALPHA_PROVIDERS.includes(provider));
}

export function resolveAuthEndpoint(provider, pool) {
  const useAlpha = shouldUseAlphaPool(provider, pool);
  return {
    useAlpha,
    baseUrl:
      useAlpha && pool.hostedDomain ? pool.hostedDomain.replace(/\/$/, '') : process.env.AUTH_URL,
    clientId: (useAlpha && pool.appClientId) || process.env.AUTH_CLIENT_ID,
  };
}

export function readAlphaLoginSession() {
  const raw = localStorage.getItem('alphaLoginSession');
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (parsed?.loginSessionId && parsed?.loginSessionSecret) {
      return parsed;
    }
    return null;
  } catch {
    localStorage.removeItem('alphaLoginSession');
    return null;
  }
}

export function persistAlphaLoginSession(data) {
  const session = data?.alphaLoginSession;
  if (session?.loginSessionId && session?.loginSessionSecret) {
    localStorage.setItem('alphaLoginSession', JSON.stringify(session));
  } else {
    localStorage.removeItem('alphaLoginSession');
  }
}

export function postOAuthForm({ provider, pool, redirectUri, state }) {
  const { baseUrl, clientId } = resolveAuthEndpoint(provider, pool);
  localStorage.setItem('loginProvider', provider);

  const form = document.createElement('form');
  form.setAttribute('method', 'GET');
  form.setAttribute('action', `${baseUrl}/authorize`);

  const params = {
    response_type: 'code',
    client_id: clientId,
    redirect_uri: redirectUri,
    scope: 'email openid profile',
    identity_provider: provider,
    ...(state ? { state } : {}),
  };

  Object.entries(params).forEach(([name, value]) => {
    const input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', name);
    input.setAttribute('value', value);
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
}
